import { z } from 'zod';
import { CAMPAIGN_TYPES } from './campaign.js';
export const AI_SUGGEST_TONES = ['formal', 'friendly', 'direct'];
export const aiSuggestOpeningSchema = z.object({
    lead_id: z.string().uuid(),
    tone: z.enum(AI_SUGGEST_TONES).optional().default('friendly'),
});
export const aiSuggestSubjectsSchema = z.object({
    lead_id: z.string().uuid(),
    tone: z.enum(AI_SUGGEST_TONES).optional().default('friendly'),
    context: z.string().max(500).optional(),
    campaign_type: z.enum(CAMPAIGN_TYPES).optional(),
    /** Default 2 voor A/B-keuze in bibliotheek. */
    count: z.number().int().min(2).max(3).optional().default(2),
});
//# sourceMappingURL=ai.js.map